import "./widgetLg.css"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { getOrders } from "../../redux/apiCalls"

export default function WidgetLg() {
  const dispatch = useDispatch()
  const orders = useSelector((state) => state.order.orders)
  useEffect(() => {
    getOrders(dispatch)
  }, [])

  const Button = ({ type }) => {
    // type: Completed , Processing, Pending
    const typeU = type.charAt(0).toUpperCase() + type.slice(1)
    return <button className={"widgetLgButton " + typeU}>{typeU}</button>
  }
  return (
    <div className='widgetLg'>
      <h3 className='widgetLgTitle'>Latest transactions</h3>
      <table className='widgetLgTable'>
        <tr className='widgetLgTr'>
          <th className='widgetLgTh'>Customer</th>
          <th className='widgetLgTh'>Date</th>
          <th className='widgetLgTh'>Amount</th>
          <th className='widgetLgTh'>Status</th>
        </tr>
        {orders &&
          orders.map((order) => {
            return (
              <tr className='widgetLgTr'>
                <td className='widgetLgUser'>
                  <span className='widgetLgName'>
                    {order.last_name} {order.first_name}
                  </span>
                </td>
                <td className='widgetLgDate'>{order.created_at}</td>
                <td className='widgetLgAmount'>${order.amount}</td>
                <td className='widgetLgStatus'>
                  <Button type={order.status} />
                </td>
              </tr>
            )
          })}
      </table>
    </div>
  )
}
